module.exports = __webpack_public_path__ + "static/media/747_clean.0bdc8bc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Seats/img/747_clean.svg
// module id = 361
// module chunks = 0